export default "__VITE_ASSET__968e6191__"